import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import url from 'url';
var queryParams = url.parse(document.location.href, true).query;
var theme = queryParams.theme || window.localStorage.getItem('mumble.theme');
var themes = {
  'MetroMumbleLight': 'MetroMumbleLight',
  'light': 'MetroMumbleLight'
};
theme = themes[theme] || window.mumbleWebConfig.defaults.theme;
window.theme = theme;

var _MetroMumbleLight$the = _slicedToArray({
  'MetroMumbleLight': [require('../../themes/MetroMumbleLight/loading.scss'), require('../../themes/MetroMumbleLight/main.scss')]
}[theme], 2),
    loadingTheme = _MetroMumbleLight$the[0],
    mainTheme = _MetroMumbleLight$the[1];

function useStyle(url) {
  var style = document.createElement('link');
  style.rel = 'stylesheet';
  style.type = 'text/css';
  style.href = url;
  document.getElementsByTagName('head')[0].appendChild(style);
}

useStyle(loadingTheme);
useStyle(mainTheme);